import React, {Component} from 'react';
import '../../asset/css/login.css';
import PageContentWallpaper from '../common/ef-pageContent';
import AddingModel from '../common/adding-model';
import {GetUserToken} from "../../api/services";

export default class SettingBankingComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {}
        this.MyModel = [
            {
                field: "ref",
                desc: "Dealer Phone Account",
                placeholder: "Dealer Phone Account",
                required: true,
                type: "text",
                readonly: false,
                staticValue: ""
            },
            {
                field: "emailusername",
                desc: "Email account or Username",
                placeholder: "Email Username",
                required: true,
                type: "text",
                readonly: false,
                staticValue: ""
            },{
                field: "EmailPassword",
                desc: "Email Password",
                placeholder: "Email Password",
                required: true,
                type: "text",
                readonly: false,
                staticValue: ""
            },
            {
                field: "emailhost",
                desc: "Email Host Server e.g mail.easipath.com",
                placeholder: "Email Host",
                required: true,
                type: "text",
                readonly: false,
                staticValue: ""
            },{
                field: "emailport",
                desc: "Email Server Port e.g 110",
                placeholder: "Email Server Port",
                required: true,
                type: "text",
                readonly: false,
                staticValue: ""
            },


            {
                field: "bankaccount",
                desc: "Bank Account",
                placeholder: "Bank Account",
                required: true,
                type: "text",
                readonly: false,
                staticValue: ""
            },
            {
                field: "bankname",
                desc: "Bank Name",
                placeholder: "Bank Name",
                required: true,
                type: "text",
                readonly: false,
                staticValue: ""
            },{
                field: "BankMask",
                desc: "Bank account mask e.g ....45693",
                placeholder: "Bank Mask",
                required: true,
                type: "text",
                readonly: false,
                staticValue: ""
            },


        ];
        this.ModelName = "DealerMailing";
        this.Crum = "/crum";
        this.PrimaryKey = "org"
    }

    /*


	BankAccount string
	BankName    string
	BankMask    string
     */
    async componentDidMount() {
        await this.isSupperUser()
    }
    isSupperUser=async ()=>{
        let user = GetUserToken();
        const role = user.Role;
        if(role!=="super"){
            alert("Sorry you can't perform this action,Your role is: "+role+"");
            window.location.href="#/home"
        }
    }


    render() {
        return (


            <PageContentWallpaper {...this.props} >

                <div className="row">
                    <div className="col-xs-12">
                        <h2>Dealer Banking & Email account</h2>
                    </div>

                </div>

                <div className="row">
                    <div className="col-xs-12">
                        <AddingModel
                            MyModel={this.MyModel}
                            ModelName={this.ModelName}
                            ListDisplayKey={["Ref","EmailUsername","BankName","BankAccount"]}
                            ListDeleteKey={[
                                {field: "ref", type: "string"},

                            ]}
                            Crum={this.Crum}
                            PrimaryKey={this.PrimaryKey}
                        />
                    </div>
                </div>


            </PageContentWallpaper>


        );
    }
}
